<template>
    <div>
        <!-- 页面固定头部 -->
        <a-anchor :getContainer="getModuleContainer" style="width:100%">
            <!-- 面包屑组件 -->
            <FGBreadHead></FGBreadHead>
            <div class="fun-panel fun-search-form-wrapper">
                <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                    <a-row :gutter="[0, 6]">
                        <a-col :span="6">
                            <a-form-item label="注销表编号">
                                <a-input v-model="queryParams.zxsqbbh" placeholder="" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="姓名">
                                <a-input v-model="queryParams.xm" placeholder="" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="单据状态">
                                <FGDictSelectCN ref="djzt" dictNo="DW300101" v-model="queryParams.djzt" mode="multiple" />
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row :gutter="[0, 6]">
                        <a-col :span="24">
                            <span class="fun-search-form-buttons" :style="{ float: 'right', overflow: 'hidden' }">
                                <a-button type="primary" @click="loadData" style="margin-right: 8px">查询</a-button>
                                <a-button @click="reset">重置</a-button>
                            </span>
                        </a-col>
                    </a-row>
                </a-form>
            </div>
        </a-anchor>
        <div class="fun-panel">
            <a-spin :spinning="tableDataLoading">
                <!-- 工具栏 -->
                <vxe-toolbar
                    size="mini"
                    custom
                    :refresh="{
                        query: () => {
                            this.loadData();
                        }
                    }"
                >
                    <template v-slot:buttons>
                        <a-button type="primary" icon="plus" @click="insert">新增</a-button>
                        <a-button-group class="btnGroupCls">
                            <a-button :type="selDJZT === 2 ? btnPrimary : btnDefault" @click="handleSelDjztChange(2)">
                                全部
                            </a-button>
                            <a-button :type="selDJZT === 0 ? btnPrimary : btnDefault" @click="handleSelDjztChange(0)">
                                待提交
                            </a-button>
                            <a-button :type="selDJZT === 1 ? btnPrimary : btnDefault" @click="handleSelDjztChange(1)">
                                已提交
                            </a-button>
                        </a-button-group>
                    </template>
                </vxe-toolbar>
                <!-- 表格 -->
                <vxe-table
                    ref="table"
                    size="mini"
                    resizable
                    auto-resize
                    row-id="id"
                    align="left"
                    :max-height="$FG_util.getTableHeightDirect(2)"
                    header-align="center"
                    highlight-hover-row
                    highlight-current-row
                    show-overflow="tooltip"
                    :data="tableData"
                    :sort-config="{
                        trigger: 'cell',
                        defaultSort: { field: sort.field, order: sort.order },
                        remote: true,
                        orders: ['asc', 'desc']
                    }"
                    @sort-change="handleSortChange"
                    @cell-dblclick="doubleClick"
                >
                    <vxe-table-column type="seq" title="序号" width="70" align="center" sortable></vxe-table-column>
                    <vxe-table-column field="djzt" title="单据状态" width="120" sortable align="center"></vxe-table-column>
                    <vxe-table-column field="zxsqbbh" title="注销表编号" width="120" sortable align="center"></vxe-table-column>
                    <vxe-table-column field="zxrq" title="注销日期" width="120" sortable align="center"></vxe-table-column>
                    <vxe-table-column field="xm" title="姓名" width="120" sortable align="center"></vxe-table-column>
                    <vxe-table-column field="xb" title="性别" width="60" align="center">
                        <template v-slot="scope">
                            <FGDictRendererCN dictNo="RY100101" :value="scope.row.xb" />
                        </template>
                    </vxe-table-column>

                    <vxe-table-column field="zjlx" title="证件类型" width="120" align="center">
                        <template v-slot="scope">
                            <FGDictRendererCN dictNo="RY100104" :value="scope.row.zjlx" />
                        </template>
                    </vxe-table-column>
                    <vxe-table-column field="zjhm" title="证件号码" width="180" align="center"></vxe-table-column>
                    <vxe-table-column field="ssdwmc" title="所属单位名称" min-width="220"></vxe-table-column>
                    <vxe-table-column field="lrrxm" title="录入人" width="120" align="center"></vxe-table-column>
                    <vxe-table-column field="lrrq" title="录入时间" width="150" align="center"></vxe-table-column>
                    <vxe-table-column title="操作" width="220" align="center">
                        <template v-slot="scope">
                            <span
                                class="btn_edit"
                                v-if="scope.row.djzt === '制定' || scope.row.djzt === '撤销' || scope.row.djzt === '否决'"
                                @click="edit(scope.row)"
                                >编辑
                            </span>
                            <span
                                class="btn_edit"
                                v-if="scope.row.djzt === '制定' || scope.row.djzt === '撤销' || scope.row.djzt === '否决'"
                                @click="remove(scope.row)"
                                >删除
                            </span>
                            <span class="btn_edit" @click="view(scope.row)">查看</span>
                        </template>
                    </vxe-table-column>
                </vxe-table>
                <vxe-pager
                    background
                    size="mini"
                    style="margin-top:5px"
                    :current-page.sync="pageinfo.pageNo"
                    :page-size.sync="pageinfo.pageSize"
                    :total="pageinfo.total"
                    :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']"
                    @page-change="handlePageChange"
                >
                </vxe-pager>
            </a-spin>
        </div>
    </div>
</template>

<script>
export default {
    name: "JsryzxwhBrowse",
    props: ["showEdit", "dataId"],
    data() {
        return {
            //  编辑器属性
            tableData: [], //表格数据
            tableDataLoading: false,

            // 分页
            pageinfo: {
                pageNo: 1,
                pageSize: 20,
                total: 0
            },
            // 排序
            sort: {
                field: "zxsqbbh",
                order: "desc"
            },
            // 查询条件
            queryParams: {},
            btnPrimary: "primary",
            btnDefault: "default",
            selDJZT: 0
        };
    },
    computed: {
        // 是否显示编辑界面
        editIsVisible: {
            get() {
                return this.showEdit;
            },
            set(newVal) {
                this.$emit("update:showEdit", newVal);
            }
        },
        formIsVisible: {
            get() {
                return this.showForm;
            },
            set(newVal) {
                this.$emit("update:showForm", newVal);
            }
        },
        // 当前编辑记录id
        editDataId: {
            get() {
                return this.dataId;
            },
            set(newVal) {
                this.$emit("update:dataId", newVal);
            }
        }
    },
    activated() {
        this.loadData(this.editDataId);
    },
    methods: {
        //双击事件
        doubleClick({ row }) {
            if (this.getState(row.djzt) === 2) {
                this.view(row);
            } else {
                this.edit(row);
            }
        },
        getState(state) {
            if (state === "制定" || state === "撤销" || state === "否决") {
                return 1;
            } else {
                return 2;
            }
        },
        //选择不同状态
        handleSelDjztChange(selType) {
            this.selDJZT = selType;
            this.loadData();
        },
        //查看
        view(row) {
            // 设置编辑记录id
            this.editDataId = row.id;
            // 显示编辑界面
            this.editIsVisible = false;
            this.formIsVisible = true;
        },
        //点击表头排序
        handleSortChange({ property, order }) {
            this.sort.field = property;
            this.sort.order = order;
            this.loadData();
        },
        // 点击明细表头排序 { property, order }
        handleItemSortChange({ property, order }) {
            this.itemSort.field = property;
            this.itemSort.order = order;
        },
        //分页点击
        handlePageChange({ currentPage, pageSize }) {
            this.pageinfo.pageNo = currentPage;
            this.pageinfo.pageSize = pageSize;
            this.loadData();
        },
        //查询列表数据
        loadData(id) {
            this.queryParams.selType = this.selDJZT;
            this.tableDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/jsry/jsryzx/list",
                    {
                        funid: "RY4000",
                        pageNo: this.pageinfo.pageNo,
                        pageSize: this.pageinfo.pageSize,
                        queryParams: this.queryParams,
                        sort: this.sort
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.tableDataLoading = false;
                    if (success) {
                        this.tableData = data.data;
                        // 需要设置当前页，因为查询可能导致当前页发生变化
                        this.pageinfo.pageNo = data.pageinfo.pagenum;
                        this.pageinfo.total = data.pageinfo.maxrow;
                    } else {
                        // 数据加载失败清空表格
                        this.tableData = [];
                    }
                })
                .then(() => {
                    this.$nextTick(() => {
                        let row = null;
                        // 获取之前选择的记录
                        if (id) {
                            row = this.$refs.table.getRowById(id);
                        }
                        // 如果之前没有选择记录且表格不为空则选择第一条记录
                        if (!row && this.tableData.length > 0) {
                            row = this.$refs.table.getRowById(this.tableData[0].id);
                        }
                        if (row) {
                            // 设置当前记录
                            this.$refs.table.setCurrentRow(row);
                        } else {
                            // 清空当前行
                            this.$refs.table.clearCurrentRow();
                        }
                    });
                });
        },
        // 新增
        insert() {
            // 设置编辑记录id
            this.editDataId = null;
            // 显示编辑窗口
            this.editIsVisible = true;
        },
        // 编辑
        edit(row) {
            // 设置编辑记录id
            this.editDataId = row.id;
            // 显示编辑窗口
            this.editIsVisible = true;
        },
        //重置文本内容
        reset() {
            this.queryParams = {};
            this.selDJZT = 0;
        },
        //删除
        remove(row) {
            this.$FG_message.confirm("P0000", "删除").then((type) => {
                if (type === "ok") {
                    this.tableDataLoading = true;

                    this.$FG_http
                        .post("./api/main/jsry/jsryzx/delete", {
                            id: row.id
                        })
                        .then(({ success, data, errMsg }) => {
                            this.tableDataLoading = false;

                            if (success) {
                                this.loadData(row.id);
                            }
                        });
                }
            });
        }
    }
};
</script>
